/**
 *
 * @module base
 * @see https://github.com/graphql/graphiql/blob/master/README.md
 * @see https://github.bamtech.co/sdk-distribution/bam-sdk/blob/master/GraphQL-Model-Component-Parts.md
 * @see https://github.bamtech.co/sdk-distribution/bam-sdk/blob/master/BAM-SDK-Mock-Environment-Cheat-Sheet.md
 *
 */

/**
 *
 * @class BaseSequence
 *
 */
export default class BaseSequence {

    /**
     *
     * @param {Object} [config={}] configuration used to build a BootstrapConfiguration instance
     * @param {SDK.Token.GeoProvider} [geoProvider=null]
     *
     */
    constructor(config = {}, geoProvider = null) {

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.config = Object.assign({
            clientId: 'launchpad',
            clientApiKey: 'bGF1bmNocGFkJmJyb3dzZXImMS4wLjA.0zmtXnjjwt_n4HoI7as5-hNiAu-yPEdK8kZpHQAk1CA',
            environment: 'qa',
            debugEnabled: false
        }, config);

        /**
         *
         * @access public
         * @type {SDK.Services.Authorization.GeoProvider}
         *
         */
        this.geoProvider = geoProvider;

    }

    /**
     *
     * @access public
     * @method execute
     * @desc runs the sequence to completion
     * @returns {Promise<Void>}
     *
     */
    execute() {

        const method = 'BaseSequence.execute()';

        return new Promise((resolve, reject) => {

            return reject(new Error(`${method} - not-implemented`));

        });

    }

}



// WEBPACK FOOTER //
// ./src/sequences/base.js